export default class ViewVotesManager {

    constructor() {
        this._localStorageKey = 'GunmaPrefecturalArchives';
        this._maxItemsCount = 5000;
        this._votesList = new Array();

        this.update();
    }

    add(items, needSave = true) {
        const addItems = items.filter((value) => !this._votesList.some(votes => votes.id === value.id));
 
        if (this._votesList.length + addItems.length >= this._maxItemsCount)
            throw new Error(`閲覧票は${this._maxItemsCount}件まで追加できます`);
        this._votesList = [...this._votesList, ...addItems];
        this.sort();
        if (needSave)
            this.saveToLocal();
    }

    remove(id, needSave = true) {
        this._votesList = this._votesList.filter(vItem => vItem.id !== id);
        if (needSave) this.saveToLocal();
    }

    removeAll() {
        this._votesList = new Array();
        localStorage.removeItem(this._localStorageKey);
        localStorage.setItem(this._localStorageKey, "");
    }

    update() {
        const votesListStr = localStorage.getItem(this._localStorageKey);

        if (!votesListStr) {
            this._votesList = new Array();
        }
        else {
            this._votesList = JSON.parse(votesListStr);
            this.sort();
        }
    }

    getList(type) {
        this.update();
        return type == null ? this._votesList : this._votesList.filter((value) => value.type === type);
    }

    saveToLocal() {
        const str = JSON.stringify(this._votesList);
        localStorage.setItem(this._localStorageKey, str);
    }

    sort() {
        this._votesList.sort((a, b) => {
            if (a.categoryOrder > b.categoryOrder)
                return 1;
            if (a.categoryOrder < b.categoryOrder)
                return -1;
            if (a.refNum2.toLowerCase() > b.refNum2.toLowerCase())
                return 1;
            if (a.refNum2.toLowerCase() < b.refNum2.toLowerCase())
                return -1;
            if (!a.bindNum && b.bindNum)
                return 1;
            if (a.bindNum && !b.bindNum)
                return -1;
            if (a.bindNum && b.bindNum) {
                if (a.bindNum > b.bindNum) return 1;
                if (a.bindNum < b.binfNum) return -1;
            }
            if (a.docNum > b.docNum)
                return 1;
            if (a.docNum < b.docNum)
                return -1;
            if (a.docNumBranch1 > b.docNumBranch1)
                return 1;
            if (a.docNumBranch1 < b.docNumBranch1)
                return -1;
            if (a.docNumBranch2 > b.docNumBranch2)
                return 1;
            if (a.docNumBranch2 < b.docNumBranch2)
                return -1;
            return 0;
        });
    };
}
